import axios from "axios";
import { getAuthHeader } from "../../utils";

export const v2_permissions = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/rbac/permissions`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_role_permissions = async (role_id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/role/permissions/${role_id}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_designation_permissions = async (designation_id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/designation/permissions/${designation_id}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_update_permission = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/rbac/update-permissions`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_update_designation_permission = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/rbac/update-designation-permissions`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

